import script from "./DividendsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DividendsView.vue?vue&type=script&setup=true&lang=ts"

import "./DividendsView.vue?vue&type=style&index=0&id=0b76d038&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b76d038"]])

export default __exports__